import { PERSIST_VALUES } from './mutations';

const persistValues = ({ commit }, payload) => commit(PERSIST_VALUES, payload);

export default {
    persistValues,
};
